import { Box, Stack } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { Button } from "@src/appV2/redesign/components/Button";
import { Card, Text, Title } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

import { SHIFT_DISCOVERY_LIST_PATH } from "../../ShiftDiscovery/paths";
import emptyCardState from "../assets/images/empty-state-card-bg-new.png";
import sunflowersSmall from "../assets/images/sunflowers-small.svg";

export function EmptyPageState() {
  const href = `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`;

  return (
    <Card
      sx={(theme) => ({
        borderRadius: 4,
        overflow: "hidden",
        width: "100%",
        height: "100%",
        position: "relative",
        backgroundColor: isRebrandingEnabled()
          ? theme.palette.background.primary
          : theme.palette.background.paper,
        display: "flex",
        flexDirection: "column",
        ...(isRebrandingEnabled()
          ? {}
          : {
              backgroundImage: `url(${emptyCardState})`,
              backgroundSize: "cover",
              backgroundPosition: "center bottom",
            }),
      })}
    >
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={4}
        sx={{
          textAlign: "center",
          flex: 1,
          paddingBottom: 10,
        }}
      >
        <Stack spacing={4}>
          <Title semibold variant="h4" component="h4">
            You don&apos;t have
            {/* eslint-disable-next-line no-restricted-syntax */}
            <br />
            any bookings
          </Title>

          <Text semibold variant="body2">
            Browse shifts near you
          </Text>
        </Stack>
        <Box sx={{ paddingTop: 6 }}>
          <Button invert={!isRebrandingEnabled()} variant="contained" size="medium" href={href}>
            Browse shifts
          </Button>
        </Box>
      </Stack>
      {isRebrandingEnabled() && (
        <Box
          component="img"
          src={sunflowersSmall}
          alt=""
          sx={{
            position: "absolute",
            bottom: "40px",
            left: "50%",
            transform: "translateX(-50%) scale(1.1)",
            transformOrigin: "bottom center",
            pointerEvents: "none",
          }}
        />
      )}
    </Card>
  );
}
